import { RouteObject } from 'react-router-dom'

import { PerformanceGeneralPage } from 'features/performance/pages/PerformanceGeneralPage'
import { PerformancePrebidStackAnalyticsPage } from 'features/performance/pages/PerformancePrebidStackAnalyticsPage'
import AuthorizedRoute from 'providers/router/components/AuthorizedRoute'
import { ROUTES } from 'routes/routePaths'
import { AuthorizedPerformanceProductRoute } from './AuthorizedPerformanceProductRoute'

export const performanceRoutes: RouteObject[] = [
  {
    element: (
      <AuthorizedRoute
        access='PerformanceGeneralPage'
        page={<PerformanceGeneralPage />}
      />
    ),
    path: ROUTES.PERFORMANCE.GENERAL,
  },
  {
    element: <AuthorizedPerformanceProductRoute />,
    path: ROUTES.PERFORMANCE.PRODUCT,
  },
  {
    element: (
      <AuthorizedRoute
        access='PerformancePrebidStackPage'
        page={<PerformancePrebidStackAnalyticsPage />}
      />
    ),
    path: ROUTES.PERFORMANCE.PREBID_STACK.ANALYTICS,
  },
]
